<template>
  <a-modal :open="open" @cancel="closeForm" class="visibility-modal">
    <h2>Настройка видимости отчетов</h2>
    <a-divider style="margin: 16px 0" />

    <div class="group-block">
        <span class="semi-bold" v-if="name && selectedUsers.length === 1">
          Пользователь
        </span>
        <span class="semi-bold" v-else>
          Пользователи
        </span>
      &ndash;
      <span class="semi-bold link" @click="() => showProductUsers()">
        {{ name ?? (selectedUsers.length + ' ' + getWordFormBasedOnTheCount(selectedUsers.length, 'сотрудник', 'сотрудника', 'сотрудников'))}}
      </span>
    </div>

    <div class="user-switches" v-if="name && selectedUsers.length === 1">
      <div class="access-switch" v-for="(report, reportKey) in tests" :key="reportKey">
        <a-switch
            :checked="isAllowed(reportKey, selectedUsers[0])"
            @change="(checked) => toggleUser(reportKey, selectedUsers[0], checked)"
        />
        <span>{{ getReportName(reportKey, true) }}</span>
      </div>
    </div>
    <div v-else>
      <a-collapse
          v-model:activeKey="activeKeys"
          :bordered="false"
          class="reports-collapse"
      >
        <template #expandIcon="{ isActive }">
          <MinusOutlined v-if="isActive" />
          <PlusOutlined v-else />
        </template>

        <a-collapse-panel
            v-for="(report, reportKey) in tests"
            :key="reportKey"
        >
          <template #header>
            <div class="panel-header" @click.stop>
              <a-checkbox
                  :checked="isAllSelected(reportKey)"
                  :indeterminate="isIndeterminate(reportKey)"
                  @change="(e) => toggleAll(reportKey, e.target.checked)"
              />
            <span class="panel-title">
              {{ getReportName(reportKey, true) }}
            </span>
            </div>
          </template>

          <div class="users-list">
            <div v-for="(u, key) in selectedUsers" :key="u">
              <div class="user-row">
                <a-checkbox
                    :checked="isUserSelected(reportKey, u)"
                    @change="(e) => toggleUser(reportKey, u, e.target.checked)"
                >
                  {{ staff.find((el) => el.id === u)?.name ?? '' }}
                </a-checkbox>
              </div>
              <a-divider v-if="(key + 1) !== selectedUsers.length" style="margin: 0" />
            </div>
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>

    <template #footer>
      <a-divider />
      <div class="action-buttons">
        <a-row justify="end" :gutter="8">
          <a-col>
            <a-button class="secondary-button" @click="closeForm">Отменить</a-button>
          </a-col>
          <a-col>
            <a-button class="primary-button" :loading="modalActionLoading" @click="setVisibility">Применить</a-button>
          </a-col>
        </a-row>
      </div>
    </template>
  </a-modal>
</template>

<script>
import {message} from "ant-design-vue";
import {useStore} from "vuex";
import {onBeforeMount, ref} from "@vue/runtime-core";
import {getWordFormBasedOnTheCount} from "../../../views/Report/utils";
import {reactive} from "@vue/reactivity";
import getReportName from "../../../mixins/getReportName";
import {MinusOutlined, PlusOutlined} from "@ant-design/icons-vue";

export default {
  components: {MinusOutlined, PlusOutlined},
  methods: {getReportName, getWordFormBasedOnTheCount},
  props: {
    open: Boolean,
    currentActionUser: Object,
    type: String,
    selectedUsers: Array,
    name: String,
    staff: Array,
  },
  emits: ['submitted', 'close'],
  setup(props, context) {
    const store = useStore();
    const modalActionLoading = ref(false);

    const tests = reactive({
      standard: {
        type: 'standard',
        can_view: [],
        ban_view: [],
      },
      full: {
        type: 'full',
        can_view: [],
        ban_view: [],
      },
      management: {
        type: 'management',
        can_view: [],
        ban_view: [],
      }
    });

    const userIds = () => (props.selectedUsers ?? []);
    const activeKeys = ref([]);

    const addUnique = (arr, id) => {
      if (!arr.includes(id)) arr.push(id)
    }

    const removeId = (arr, id) => {
      const i = arr.indexOf(id)
      if (i !== -1) arr.splice(i, 1)
    }

    const isUserSelected = (reportKey, userId) =>
        tests[reportKey].can_view.includes(userId)

    const selectedCount = (reportKey) => tests[reportKey].can_view.length
    const totalCount = () => props.selectedUsers?.length ?? 0

    const isAllSelected = (reportKey) =>
        totalCount() > 0 && selectedCount(reportKey) === totalCount()

    const isIndeterminate = (reportKey) => {
      const c = selectedCount(reportKey)
      return c > 0 && c < totalCount()
    }

    const isAllowed = (reportKey, userId) =>
        tests[reportKey].can_view.includes(userId)

    const toggleUser = (reportKey, userId, checked) => {
      const {can_view, ban_view} = tests[reportKey]
      if (checked) {
        if (!can_view.includes(userId)) can_view.push(userId)
        const i = ban_view.indexOf(userId)
        if (i !== -1) ban_view.splice(i, 1)
      } else {
        const i = can_view.indexOf(userId)
        if (i !== -1) can_view.splice(i, 1)
        if (!ban_view.includes(userId)) ban_view.push(userId)
      }
    }

    const toggleAll = (reportKey, checked) => {
      const ids = userIds()
      if (checked) {
        tests[reportKey].can_view = [...ids];
        tests[reportKey].ban_view = [];
      } else {
        tests[reportKey].can_view = [];
        tests[reportKey].ban_view = [...ids];
      }
    }

    const setVisibility = () => {
      modalActionLoading.value = true

      store.dispatch('test/manageReportAccess', {
        tests: tests,
      })
          .then(() => {
            message.success('Данные сохранены');
            // context.emit('submitted')
          })
          .finally(() => { modalActionLoading.value = false })
    }

    const closeForm = () => {
      context.emit('close');
    }

    const initDefaults = () => {
      for (const reportKey of Object.keys(tests)) {
        tests[reportKey].ban_view = [...props.selectedUsers ?? []]
        tests[reportKey].can_view = []
      }
    }

    const showProductUsers = () => {
      let staff = props.selectedUsers;
      store.dispatch('users/setSpecialStaff', staff).then(() => {
        context.emit('showStaff');
      });
    }

    onBeforeMount(() => {
      if (props.selectedUsers?.length) initDefaults();
    });

    return {
      activeKeys,
      tests,
      isUserSelected,
      isAllSelected,
      isIndeterminate,
      toggleUser,
      toggleAll,
      closeForm,
      setVisibility,
      modalActionLoading,
      showProductUsers,
      isAllowed
    }
  }
}
</script>

<style scoped lang="scss">
  .visibility-modal {

    .link {
      color: var(--primary-link-green);
      cursor: pointer;
    }

    .link:hover {
      color: var(--main-green);
    }

  }

  :deep(.ant-collapse) {
    background-color: unset;
  }

  :deep(.ant-collapse-item) {
    margin-bottom: 12px !important;
    border-bottom: unset !important;

  }

  :deep(.ant-collapse-expand-icon) {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px !important;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    background: #fff;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s, transform 0.2s;
    color: var(--main-font);
    padding-inline-end: unset !important;
    margin-right: 16px !important;
  }

  :deep(.ant-collapse-header) {
    padding: 5px 10px !important;
    background-color: rgba(0, 0, 0, 0.02);
    border-bottom: 1px solid #d9d9d9;
  }

  :deep(.ant-collapse-content-box) {
    padding: 0 !important;
  }


  .access-switch {
    display: flex;
    column-gap: 12px;
    align-items: center;
  }

  .group-block {
    font-size: 16px;
    margin-bottom: 16px;
  }

  .user-switches {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }

  .panel-title {
    margin-left: 16px;
  }

  .user-row {
    padding: 8px 0;
    padding-left: 44px;
    display: flex;
    column-gap: 16px;
  }
</style>